module.exports = __webpack_public_path__ + "static/media/video-yardnapha-issue-two.24d8e095.png";